import { createSlice } from '@reduxjs/toolkit';
import * as actionTypes from '../actions/actionTypes';


export const getInitialState = () => ({
	sampleSetDataIsLoading: false,
	sampleSetDataHasErrored: false,
	sampleSetDataIsSaving: false,
	current: 0,
	data: [],
	authenticated: false
});


export const sampleSetDataSlice = createSlice({
	name: 'sampleSetData',
	initialState: getInitialState(),
	reducers: {
		sampleSetDataIsSelected: (state, action) => {
			return { ...state, current: action.payload };
		},
		reset: () => {
			return getInitialState();
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(actionTypes.SAMPLESETDATA_HAS_ERRORED, (state) => {
				state.sampleSetDataIsLoading = false
				state.sampleSetDataHasErrored = true
			})
			.addCase(actionTypes.SAMPLESETDATA_IS_LOADING, (state) => {
				state.sampleSetDataIsLoading = true
			})
			.addCase(actionTypes.SAMPLESETDATA_FETCH_DATA_SUCCESS, (state, action) => {
				state.sampleSetDataIsLoading = false
				state.data = Array.isArray(action.response) ? action.response : Object.values(action.response)
				state.authenticated = action.authenticated || false
			})
			.addCase(actionTypes.SAMPLESETDATA_IS_SAVING, (state, action) => {
				state.sampleSetDataIsSaving = action.isSaving
			});
	}
});

export const sampleSetDataReducer = sampleSetDataSlice.reducer;
export const { sampleSetDataIsSelected, reset } = sampleSetDataSlice.actions;